import React from 'react'
import createReactClass from 'create-react-class'
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table'
import ReactJson from 'react-json-view'
import Pagination from 'react-js-pagination'
import './search-result.scss'

export default createReactClass({
  getColumns () {
    let list = []
    for (let i = 0; i <= this.props.companies.length; i++) {
      for (let key in this.props.companies[i]) {
        if (list.indexOf(key) === -1) {
          list.push(key)
        }
      }
    }
    return list
  },
  rowFormatter (cell, row) {
    if (typeof cell === 'object' && !Array.isArray(cell) && cell !== null) {
      return <div title={cell.simpleValue}>{cell.simpleValue ? <span>{cell.simpleValue}</span> : <span></span>}</div>
    } else {
      return <div title={cell}>{cell ? <span>{cell}</span> : <span>-</span>}</div>
    }
  },
  getWidth (key) {
    if (key === 'id' || key === 'dateOfLatestChange' || key === 'dateOfLatestAccounts' || key === 'name') {
      return '230'
    } else if (key === 'country') {
      return '100'
    } else if (key === 'address' || key === 'vatNo') {
      return '250'
    } else {
      return '120'
    }
  },
  showReport (id) {
    this.props.history.push({
      pathname: `/search/report`,
      search: `?${id}`,
    })
  },
  requestReport (cell, row) {
    return (
      <button className="btn btn-info" title="Request Report" onClick={this.showReport.bind(this, row.id)}>
        <span className="glyphicon glyphicon-file"></span>
      </button>
    )
  },
  handlePageChange (pageNumber) {
    this.props.onPageChange(pageNumber)
    this.props.searchCompanies(this.props.params, pageNumber, this.props.pageSize)
  },
  onRowSelect (row) {
    this.showReport(row.id)
  },
  render () {
    return (
      <div className="search-result-panel">
        {this.props.loader
          ? <div className='loader-ctr'><span className="loading"></span></div>
          : <div>
            <Tabs>
              <TabList>
                <Tab>Table View</Tab>
                <Tab>Raw JSON</Tab>
                {this.props.totalSize > 0
                  ? <div className="col-lg-6 col-md-6 col-sm-6 pull-right search-info">
                    <div className="col-lg-6 col-md-6 col-sm-6">
                      Companies found:
                      <span className='value-color'>{this.props.totalSize}</span>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6">
                      Results returned in:
                      <span className='value-color'>{this.props.resTime ? this.props.resTime.toFixed(2) : 0} Seconds</span>
                    </div>
                  </div>
                  : ''}
              </TabList>

              <TabPanel>
                {this.props.error
                  ? <div className="connect-error-alert">{this.props.error.messages[0].text}</div>
                  : <div className="cs-search-table">
                    <BootstrapTable data={this.props.companies} keyField='id' striped hover condensed trClassName='bootstrap-table-tr' options={{onRowClick: this.onRowSelect}}>
                      {this.getColumns().map((column, index) =>
                        <TableHeaderColumn dataField={column} dataAlign='center' width={this.getWidth(column)} key={index} dataFormat={this.rowFormatter} dataSort={true}>{(column.substring(0, 1).toUpperCase() + column.substring(1)).split(/(?=[A-Z])/).join(' ')}</TableHeaderColumn>
                      )}
                    </BootstrapTable>
                  </div> }
              </TabPanel>
              <TabPanel>
                <div className='raw-json-view'>
                  <ReactJson src={this.props.error ? this.props.error : this.props.companies}/>
                </div>
              </TabPanel>
            </Tabs>
            {this.props.totalSize > this.props.pageSize
              ? <div>
                <Pagination
                  activePage={this.props.pageNo}
                  itemsCountPerPage={this.props.pageSize}
                  totalItemsCount={this.props.totalSize}
                  pageRangeDisplayed={this.props.pageRange}
                  onChange={this.handlePageChange}
                />
              </div>
              : null}
          </div>
        }
      </div>
    )
  },
})



// WEBPACK FOOTER //
// ./src/components/search-result.js